export function initInterfaceStates({
  isResizingClass = 'is-resizing',
  isResizingTimeout = 100,
  parentElement = document.body,
} = {}) {
  let timer;
  window.addEventListener('resize', () => {
    parentElement.classList.add(isResizingClass);

    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      parentElement.classList.remove(isResizingClass);
      timer = null;
    }, isResizingTimeout);
  });
}
